import script from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewsSection.vue?vue&type=style&index=0&id=bcfcf3cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcfcf3cc"]])

export default __exports__